import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const MENU = [
  { label: '🏠 Главная',       href: '/admin' },
  { label: '📋 Деятельность',  href: '/admin/activities' },
  { label: '📰 Новости',       href: '/admin/news' },
  { label: '🗺️ Регионы',      href: '/admin/regions' },
  { label: '❓ FAQ',           href: '/admin/faq' },
  { label: '📬 Обращения',     href: '/admin/feedback' },
  { label: '🖼️ Слайдер',      href: '/admin/slider' },
  { label: '📞 Контакты',     href: '/admin/contacts' },
  { label: '🔗 Соцсети',      href: '/admin/social-links' },
  { label: '👥 Сотрудники',   href: '/admin/workers' },
  { label: '📁 Категории',    href: '/admin/categories' },
  { label: '📝 Как вступить',  href: '/admin/join' },
  { label: '📁 Документы',     href: '/admin/documents' },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.layout}>
      {/* Burger button for mobile */}
      <button style={styles.burgerBtn} onClick={() => setSidebarOpen(true)} className="admin-burger">
        <span /><span /><span />
      </button>

      {/* Overlay */}
      {sidebarOpen && <div style={styles.overlay} onClick={() => setSidebarOpen(false)} />}

      {/* Sidebar */}
      <aside style={{ ...styles.sidebar, transform: sidebarOpen ? 'translateX(0)' : undefined }} className="admin-sidebar">
        <button style={styles.closeBtn} onClick={() => setSidebarOpen(false)} className="admin-close">✕</button>
        <div style={styles.sidebarTitle}>Админ-панель</div>
        <nav>
          {MENU.map(item => (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => setSidebarOpen(false)}
              style={{
                ...styles.menuItem,
                background: location.pathname === item.href ? 'rgba(255,255,255,0.15)' : 'transparent',
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <button onClick={handleLogout} style={styles.logoutBtn}>🚪 Выйти</button>
      </aside>

      {/* Content */}
      <main style={styles.content}>
        <Outlet />
      </main>

      <style>{`
        .admin-burger {
          display: none;
          position: fixed;
          top: 16px;
          left: 16px;
          z-index: 100;
          flex-direction: column;
          gap: 5px;
          background: #1a3a6b;
          border: none;
          cursor: pointer;
          padding: 10px;
          border-radius: 8px;
        }
        .admin-burger span {
          display: block;
          width: 24px;
          height: 2px;
          background: #fff;
          border-radius: 2px;
        }
        .admin-close {
          display: none;
        }
        @media (max-width: 768px) {
          .admin-burger { display: flex; }
          .admin-sidebar {
            position: fixed !important;
            left: 0;
            top: 0;
            height: 100vh !important;
            z-index: 200;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
          }
          .admin-close {
            display: block;
            align-self: flex-end;
            background: rgba(255,255,255,0.15);
            border: none;
            color: #fff;
            font-size: 1.4rem;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            cursor: pointer;
            margin: 8px 16px 16px;
          }
        }
      `}</style>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  layout: { display: 'flex', minHeight: '100vh', position: 'relative' },
  sidebar: {
    width: 220,
    background: '#1a3a6b',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0',
    position: 'sticky',
    top: 0,
    height: '100vh',
    overflowY: 'auto',
  },
  sidebarTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    padding: '0 20px 20px',
    borderBottom: '1px solid rgba(255,255,255,0.15)',
    marginBottom: 8,
  },
  menuItem: {
    display: 'block',
    padding: '12px 20px',
    color: 'rgba(255,255,255,0.85)',
    textDecoration: 'none',
    fontSize: '0.9rem',
    transition: 'background 0.15s',
    borderRadius: 0,
  },
  content: { flex: 1, background: '#f0f4fb', overflowY: 'auto', minWidth: 0 },
  logoutBtn: {
    marginTop: 'auto',
    margin: '20px',
    padding: '10px',
    background: 'rgba(255,255,255,0.1)',
    color: '#fff',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  burgerBtn: {},
  closeBtn: {},
  overlay: {
    position: 'fixed' as const,
    inset: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 150,
  },
};
